import { HttpMethod, HttpOption, ContentType } from '@/utils/http-client'

export class ReceiptAPIConstant {
    /**
     * 付款失败/放款失败
     */
    PayFail = (data: any): HttpOption => ({
        url: '/front/abroadPayment/payFail',
        method: HttpMethod.POST,
        data
    })

    /**
     * 重新放款
     */
    PayResend = (data: any): HttpOption => ({
        url: '/front/abroadPayment/payResend',
        method: HttpMethod.POST,
        data
    })

    /**
     * 放款拒绝/取消放款（发送三方前拦截 & 放款失败后取消放款）
     */
    PayReject = (data: any): HttpOption => ({
        url: '/front/abroadPayment/payReject',
        method: HttpMethod.POST,
        data
    })

    /**
     * 付款审核/放款成功
     */
    ConfirmPay = (data: any): HttpOption => ({
        url: '/front/abroadPayment/confirmPay',
        method: HttpMethod.POST,
        data
    })

    /**
     * 变更放款状态：手动放款→系统放款
     */
    ChangeOprType = (data: any): HttpOption => ({
        url: '/front/abroadPayment/changeOprType',
        method: HttpMethod.POST,
        data
    })

    /**
     * 导出放款单列表
     */
    ExportAbroadPaymentList = (params: any): HttpOption => ({
        url: '/front/abroadPayment/export',
        method: HttpMethod.GET,
        params
    })

    /**
     * 根据条件分页查询放款单列表
     */
    AbroadPaymentList = (data: any): HttpOption => ({
        url: '/front/abroadPayment/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据条件查询总金额
     */
    AbroadPaymentListAmount = (data: any): HttpOption => ({
        url: '/front/abroadPayment/listAmount',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据进件id查询放款明细
     */
    OutcomeDetailList = (data: any): HttpOption => ({
        url: '/front/abroadPayment/getOutcomeDetailList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 手动创建还款码
     */
    CreateRepaymentCode = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/createRepaymentCode',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询还款支付渠道列表
     */
    RepaymentPayChannelList = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/queryRepaymentPayChannelList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据订单号查询待还总金额
     */
    RepaymentTotalAmountByOrderId = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/getRepaymentTotalAmountByOrderId',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询还款支付类型列表
     */
    RepaymentPayTypeList = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/queryRepaymentPayTypeList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据条件分页查询还款单列表
     */
    AbroadDeductList = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据条件查询总金额
     */
    AbroadDeductListAmount = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/listAmount',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据还款单id查询还款单明细列表
     */
    AbroadDeductGetDetailList = (data: any): HttpOption => ({
        url: '/front/abroadDeduct/getDetailList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 导出还款单列表
     */
    ExportAbroadRePaymentList = (params: any): HttpOption => ({
        url: '/front/abroadDeduct/export',
        method: HttpMethod.GET,
        params
    })

    /**
     * 获取招领单据列表
     */
    BankSlipsList = (data: any): HttpOption => ({
        url: '/front/pmcBankSlips/page',
        method: HttpMethod.POST,
        data
    })

    /**
     * 获取操作人员
     */
    Operators = (params: any): HttpOption => ({
        url: '/front/pmcBankSlips/getOperators',
        method: HttpMethod.GET,
        params
    })

    /**
     * 上传文件
     */
    BankSlipsFile = (data: any): HttpOption => ({
        url: '/front/pmcBankSlips/uploadBankSlipsFile',
        method: HttpMethod.POST,
        headers: {
            'Content-Type': ContentType.MULTI_FORM
        },
        data
    })

    /**
     * 查询相关订单
     */
    BindingList = (data: any): HttpOption => ({
        url: '/front/documentBinding/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 提交绑定
     */
    BindingSubmit = (data: any): HttpOption => ({
        url: '/front/documentBinding/submit',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询汇总金额
     */
    AllAmount = (data: any): HttpOption => ({
        url: '/front/pmcBankSlips/getAllAmount',
        method: HttpMethod.POST,
        data
    })

    /**
     * 下载模板
     */
    Download = (): HttpOption => ({
        url: '/front/pmcBankSlips/download',
        method: HttpMethod.GET,
        responseType: 'blob',
        headers: {
            'Content-Disposition': 'attachment; filename=template.xlsx',
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        }
    })
}
